import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PageSlotModule } from '@spartacus/storefront';

import { AbstractPageComponent } from '../../templates/abstract-page/abstract-page.component';
import { CustomJsonLdDirective } from '../../directives';
import { CustomAuthService } from '../../services';

@Component({
  selector: 'wc-homepage',
  templateUrl: './homepage.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PageSlotModule,
    CustomJsonLdDirective
  ]
})
export class HomepageComponent extends AbstractPageComponent implements OnInit {
  constructor(
    private readonly authService: CustomAuthService,
    private readonly route: ActivatedRoute
  ) {
    super();

    this.snippetsOptions = { images: true };
    this.eagerLoadingSlot = 'DynamicBody';
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.route.snapshot.queryParamMap.has('login')) {
      this.authService.toggleLoginWithRedirect(undefined, false);
    }
  }
}
